export function removeUnitFromListWithID(list, obj) {
    if (obj instanceof Array) {
        for (let i = 0; i < obj.length; i++) {
            removeUnitFromListWithID(list, obj[i]);
        }
    } else {
        let index = 0;
        for (index = 0; index < list.length; index++) {
            if (list[index].ID === obj.ID) {
                break;
            }
        }
        list.splice(index, 1);
    }
}
